import React, { useEffect, useState } from "react";
import { FaFolderOpen } from "react-icons/fa";
import CustomSwitch from "shared/components/Switch/CustomSwitch";
import { usePutAtualizarConfigAssinanteDocumento } from "hooks/groupsign/usePutAtualizarConfigAssinanteDocumento";
import { ListaAssinantes } from "./ListaAssinante";
import { Typography } from "@mui/material";
import { ConfigAssinanteDocumentoDTO } from "types/dto/groupsign/ConfigAssinanteDocumentoDTO";
import { FaPencil } from "react-icons/fa6";
import { AssinanteDocumentoDTO } from "types/dto/groupsign/AssinanteDocumentoDTO";
import { usePutAtualizarAssinanteDocumento } from "hooks/groupsign/usePutAtualizarAssinanteDocumento";
import { toast } from "react-hot-toast";
import { usePostCriarConfigAssinanteDocumento } from "hooks/groupsign/usePostCriarConfigAssinanteDocumento";
import { Grid } from "@mui/material";
import "./hyperLinkGroupSign.css";
import { usePermissoesContext } from "context/permissoes/PermissoesContext";
import { TipoPermissao } from "constants/EnumTipoPermissao";

interface SectionAssDigitalProps {
  title: string;
  isAtivo: boolean;
  isEditing: boolean;
  setIsEditing: React.Dispatch<React.SetStateAction<boolean>>;
  config: ConfigAssinanteDocumentoDTO;
  configAssDigitalUuid: string;
  refetch: () => void;
  updateIsAtivo: (isAtivo: boolean) => void;
  control: any;
  trigger: any;
  register: any;
  setValue: any;
  watch: any;
  showInputEmail: boolean;
  setShowInputEmail: (showInputEmail: boolean) => void;
  setEditingSection: (uuid: string | null) => void;
}

export const SectionAssDigital: React.FC<SectionAssDigitalProps> = ({
  title,
  isAtivo,
  isEditing,
  setIsEditing,
  config,
  configAssDigitalUuid,
  refetch,
  updateIsAtivo,
  control,
  trigger,
  register,
  setValue,
  watch,
  showInputEmail,
  setShowInputEmail,
  setEditingSection,
}) => {
  const { mutate: updateConfig } = usePutAtualizarConfigAssinanteDocumento();
  const { mutate: updateAssinante } = usePutAtualizarAssinanteDocumento();
  const { mutate: criarConfigAssinanteDocumento } = usePostCriarConfigAssinanteDocumento();
  const [assinanteLocalOrder, setAssinanteLocalOrder] = useState<AssinanteDocumentoDTO[]>(
    Array.isArray(config.assinanteDocumentoResponses) ? config.assinanteDocumentoResponses : []
  );
  const { usuarioPossuiPermissao } = usePermissoesContext();
      const possuiPermissaoEditarConfiguracaoCondominio = usuarioPossuiPermissao(
        "configuracaoCondominio",
        TipoPermissao.ALTERAR
    );

  useEffect(() => {
    if (Array.isArray(config.assinanteDocumentoResponses)) {
      const sortedAssinantes = [...config.assinanteDocumentoResponses].sort((a, b) => a.ordem - b.ordem);
      setAssinanteLocalOrder(sortedAssinantes);
    }
  }, [config]);

  const handleSwitchChange = (newIsAtivo: boolean) => {
    const actionText = newIsAtivo ? "ativada" : "desativada";

    if (newIsAtivo === false) {
      setEditingSection(null);
      setValue("select-responsavel-legal", []);
    }

    if (!config || !config.uuid) {
      const novoPayload: Partial<ConfigAssinanteDocumentoDTO> = {
        tipoDocumento: "PASTA_PRESTACAO_CONTAS",
        isAtivo: newIsAtivo,
        configuracaoAssinaturaDigitalCondominioUuid: configAssDigitalUuid,
        assinanteDocumentoResponses: [],
      };

      criarConfigAssinanteDocumento(novoPayload as ConfigAssinanteDocumentoDTO, {
        onSuccess: () => {
          refetch();
        },
      });

      return;
    }

    if (newIsAtivo !== isAtivo) {
      const updatedConfig = { ...config, isAtivo: newIsAtivo };

      updateConfig(updatedConfig, {
        onSuccess: () => {
          updateIsAtivo(newIsAtivo);
          refetch();
          toast.success(`Assinatura ${actionText} com sucesso`);
        },
      });
    }
  };

  const handleReorder = (newOrder: AssinanteDocumentoDTO[]) => {
    setAssinanteLocalOrder(newOrder);
    newOrder.forEach((assinante, index) => {
      const updatedAssinante = { ...assinante, ordem: index + 1, configuracaoAssinanteDocumentoUuid: config.uuid };

      updateAssinante(updatedAssinante, {
        onSuccess: () => {
          refetch();
        },
      });
    });
  };

  const renderSwitchSection = () => (
    <div style={{ marginLeft: "auto", marginRight: 15, display: "flex", alignItems: "center", gap: "20px" }}>
      {!isEditing && isAtivo && (
        <Grid display="flex" justifyContent="center">
          {possuiPermissaoEditarConfiguracaoCondominio && (
            <span className={`hyperlink-editar`} onClick={() => isAtivo && setIsEditing(true)}>
              <FaPencil size={12} />
              Editar
            </span>
           )}
        </Grid>
      )}
      {possuiPermissaoEditarConfiguracaoCondominio && (
        <CustomSwitch
          labelDireito="Assinatura ativa"
          checked={isAtivo}
          onChange={(e) => handleSwitchChange(e.target.checked)}
          usarValidacaoParaFormulario={false}
        />
      )}
    </div>
  );

  return (
    <div style={{ marginBottom: "20px" }}>
      <div className="section-title" style={{ display: "flex", alignItems: "center" }}>
        <div className="header-section-icon">
          <FaFolderOpen />
        </div>
        <Typography style={{ fontSize: "1rem", fontWeight: "bold" }}>{title}</Typography>
        {renderSwitchSection()}
      </div>

      <div className="section-content-gc">
        <ListaAssinantes
          assinantes={assinanteLocalOrder}
          onReorder={handleReorder}
          isEditing={isEditing}
          configuracaoAssinanteDocumentoUuid={config.uuid}
          configuracaoAssinaturaDigitalCondominioUuid={config.configuracaoAssinaturaDigitalCondominioUuid}
          control={control}
          trigger={trigger}
          register={register}
          setValue={setValue}
          watch={watch}
          showInputEmail={showInputEmail}
          setShowInputEmail={setShowInputEmail}
          refetch={refetch}
          setAssinanteLocalOrder={setAssinanteLocalOrder}
        />
      </div>
    </div>
  );
};
